import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, PopoverController, ToastController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { PopupPage } from '../popup/popup';
import { CalendarPage } from '../calendar/calendar';

/**
 * Generated class for the ChooseindoorpausePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-chooseindoorpause',
  templateUrl: 'chooseindoorpause.html',
})
export class ChooseindoorpausePage {
  radioPause = '-1';
  pausetypes = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public alertCtrl: AlertController, public popoverCtrl: PopoverController, public toastCtrl: ToastController) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChooseindoorpausePage');
    var _that = this
    this.gn._Post('/api/gn/getindoorpausetypes', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.pausetypes = _data.data
      _that.pausetypes.push({ id: 0, clientid: _that.gn.user.ClientId, pausetype: _that.dic.l["ostanato"] })
    });
  }

  savePauseType() {
    if (this.radioPause == '-1') {
      var _that = this
      const toast = this.toastCtrl.create({
        message: _that.dic.l["choosepausetype"] + '.',
        duration: 6000,
        position: 'top'
      });
      toast.present();
    } else {
      var cb = this.navParams.get('cb')
      cb(this.radioPause)
      this.navCtrl.pop()
    }

  }



  ionViewDidLeave() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/chooseindoorpause/chooseindoorpause.ts